/**
 * "time ago" for a sent message / last activity: relative under a day,
 * weekday + time up to a week, then date + time. Shared by chat message
 * timestamps and the conversation picker.
 */
export function formatSentTime(iso?: string): string {
  if (!iso) return '';
  const then = new Date(iso);
  const ms = Date.now() - then.getTime();
  if (Number.isNaN(ms)) return '';
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  const time = then.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  });
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `${then.toLocaleDateString([], { weekday: 'short' })} ${time}`;
  }
  return `${then.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${time}`;
}
